module.exports = __webpack_public_path__ + "img/icon-keywords.12beb780.svg";